function Loader() {
  return (
    <div className="dot-loader preloader">
      <span></span><span></span><span></span><span></span>
    </div>
  )
}

export default Loader
